module.exports = __webpack_public_path__ + "static/img/bg.5fadfd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/bg.png
// module id = NwKx
// module chunks = 70